import React from "react";
import { CustomerCard } from "./customer-card";

export function CustomersList({ rows, onViewDetails }) {
  if (!rows.length) {
    return (
      <p className="my-0 py-12 text-center text-[14px] font-medium text-[#9CA3AF]">
        No customers match your search.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3 sm:gap-4">
      {rows.map((customer) => (
        <CustomerCard
          key={customer.id}
          customer={customer}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
}
